import { styled as t } from "styled-components";
import { skeletonFadeAnimation as i } from "../../../styles/animation.js";
import { MediaQuery as r } from "../../../styles/variables.js";
import { TextCapsule as a } from "../../../components/TextCapsule/index.js";
import { Theme as o } from "../../../styles/themes/index.js";
import { Carousel as e } from "../../../components/Carousel/index.js";
const c = t(a)`
  color: rgb(${o.colors.Alpha});
  background-color: rgb(${o.colors.Papa});

  @media ${r.SCREEN_MD_UP} {
    background-color: rgb(${o.colors.Juliet});
  }
`, u = t.div`
  ${({ animate: n }) => i({ animate: n, disableBackground: !0 })}
`, b = t.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;

  @media ${r.SCREEN_MD_UP} {
    width: 180%;
  }

  @media ${r.SCREEN_LG_UP} {
    width: 100%;
  }
`, C = t.div`
  width: 100%;
  overflow: hidden;
  margin-bottom: 8px;
  margin-left: 40px;
`;
t.div`
  margin-bottom: 14px;
`;
const x = t(e.PrevIndicator)`
  && {
    & > button {
      margin-left: 0;
      width: 20px;
      height: 20px;

      @media ${r.SCREEN_SM} {
        display: none;
      }
    }
    i {
      color: rgb(${o.colors.Brand});
      font-size: 16px;
      margin-top: 1px;
    }

    &::before {
      margin-left: -2px;
      background: linear-gradient(
        to left,
        transparent 0,
        rgb(${o.colors.Juliet}) 76%
      );

      @media ${r.SCREEN_MD_UP} {
        background: linear-gradient(
          to left,
          transparent 0,
          rgb(${o.colors.Papa}) 76%
        );
      }
    }
  }
`, f = t(e.NextIndicator)`
  && {
    & > button {
      margin-right: 0;
      width: 20px;
      height: 20px;

      @media ${r.SCREEN_SM} {
        display: none;
      }
    }
    i {
      color: rgb(${o.colors.Brand});
      font-size: 16px;
      margin-top: 1px;
    }

    &::before {
      margin-right: -2px;
      background: linear-gradient(
        to right,
        transparent 0,
        rgb(${o.colors.Juliet}) 76%
      );

      @media ${r.SCREEN_MD_UP} {
        background: linear-gradient(
          to right,
          transparent 0,
          rgb(${o.colors.Papa}) 76%
        );
      }
    }
  }
`, h = t(e.Root)`
  margin-bottom: 8px;
`;
export {
  C as CommentCarouselContainerSkeleton,
  b as CommentCarouselListSkeleton,
  u as CommentContainerSkeleton,
  c as CommentSuggestionsCarouselCapsule,
  f as CustomNextButton,
  x as CustomPrevButton,
  h as CustomRoot
};
